
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/study-abroad-recruiter",
      function () {
        return require("private-next-pages/partners/study-abroad-recruiter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/study-abroad-recruiter"])
      });
    }
  